import { Outlet, useParams } from "react-router";
import "@ant-design/v5-patch-for-react-19";
import ProtectedRoute from "./route/protected.route";
import { useDispatch } from "react-redux";
import Navbar from "./components/Navbar";
import SideBar from "./components/siderbar/SideBar";
import { useAPI } from "./hooks/useAPI";
import { ENDPOINTS } from "./constants/endpoints.constant";
import { EventData } from "./models/event";
import { useEffect } from "react";
import { getCall } from "./constants/apicalls.constant";
import { message } from "antd";
import { setSelectedEventList } from "./store/slices/event.slice";
import Loader from "./components/Loader";
import AuthChecker from "./components/AuthChecker";
import WorkspaceChecker from "./components/WorkspaceChecker";


function App() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { response, loading, error, trigger } = useAPI<{
    status: boolean;
    message: string;
    data: EventData;
  }>(ENDPOINTS.event);

  const getEventData = async () => {
    const res = await trigger(getCall({}, id));
    if (res?.status) {
      if (res?.data?.id) {
        dispatch(setSelectedEventList(res?.data));
      }
    } else {
      message.error(res?.message);
    }
  };
  useEffect(() => {
    if (id) {
      getEventData();
    }
  }, [id]);
  if (loading) return <Loader />;
  if (error) return <>something went wrong....</>;

  return (
    <ProtectedRoute
      element={
        <>
          <Navbar />
          <div className="flex">
            {id && <SideBar />}

            <main
              className="w-full overflow-hidden min-h-screen"
              style={{ background: "#F8FAFC" }}
            >
              <WorkspaceChecker>
                <AuthChecker
                  permissions={
                    response?.data?.permissions?.event_access?.permissions ?? []
                  }
                >
                  <Outlet />
                </AuthChecker>
              </WorkspaceChecker>
            </main>
          </div>
        </>
      }
    />
  );
}

export default App;
